module.exports = __webpack_public_path__ + "img/sld_scb_4_t1_green.1c3e0f3d.svg";